import { Card } from "../_shared/card";
import { IconPin } from "../_shared/icons";
import { navigate } from "../_shared/router";
import { children } from "../_data/mock";
import { useDemo } from "../_shared/demo.provider";
import { formatFrenchDate } from "../_shared/date-fmt";

const childPill = {
  orange: "bg-[var(--child-1-light)] text-[var(--child-1-primary)]",
  blue: "bg-[var(--child-2-light)] text-[var(--child-2-primary)]",
} as const;

export function AppointmentsCard() {
  const { upcomingAppointments } = useDemo();

  return (
    <Card
      title="Rendez-vous"
      icon={<IconPin width={22} height={22} />}
      onClick={() => navigate("appointments")}
    >
      {upcomingAppointments.length === 0 ? (
        <p className="text-[13px] text-[var(--text-2)]">
          Aucun rendez-vous prévu.
        </p>
      ) : (
        <ul className="space-y-2 text-[14.5px]">
          {upcomingAppointments.map((rdv) => {
            const child = children.find((c) => c.id === rdv.childId);
            if (!child) return null;
            return (
              <li key={rdv.id} className="flex items-center gap-3">
                <span
                  className={`inline-flex h-6 min-w-14 items-center justify-center rounded-full px-2.5 text-[11.5px] font-semibold ${childPill[child.color]}`}
                >
                  {child.firstName}
                </span>
                <span className="text-[var(--text-1)] first-letter:uppercase">
                  {formatFrenchDate(rdv.isoDate)} · {rdv.time}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </Card>
  );
}
